const COLOUR_HEX_MAP = {
  ivory: '#FFFFF0',
  white: '#FFFFFF',
  champagne: '#F7E7CE',
  blush: '#F5C6CB',
  black: '#000000',
  blue: '#0000FF',
  gold: '#FFD700',
  pink: '#FFC0CB',
  purple: '#800080',
  red: '#FF0000',
  green: '#008000',
  yellow: '#FFFF00',
  gray: '#808080',
  orange: '#FFA500',
  mint: '#98FB98',
  mocha: '#967259'
};

export function getColourHex(colour) {
  return COLOUR_HEX_MAP[colour] || '#CCCCCC';
}

export function getColourLabel(t, colour) {
  if (!colour) return null;
  return t(`dresses.colors.${colour}`, colour.charAt(0).toUpperCase() + colour.slice(1));
}
